import { APP_NAME, TITLE_SEPARATOR } from "./app-name";

/**
 * Builds the browser-tab text from an already-translated page name.
 *
 * Pure on purpose: translation happens in the caller so it can subscribe to
 * language changes. See ./document-title.tsx.
 */
export function composeDocumentTitle(
	translatedTitle: string | undefined
): string {
	const trimmed = translatedTitle?.trim();

	if (!trimmed || trimmed === APP_NAME) {
		return APP_NAME;
	}

	return `${trimmed}${TITLE_SEPARATOR}${APP_NAME}`;
}
